import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "devicetype-packetparser"
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.duplicateKeys.title'),
      "color": "danger",
      "open": _vm.parserDuplicateKeysPrompt,
      "buttons": [{
        text: _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.duplicateKeys.saveAnyway'),
        color: 'danger',
        emit: 'save'
      }, {
        text: _vm.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.parserDuplicateKeysPrompt = false;
      },
      "save": function ($event) {
        _vm.parserDuplicateKeysPrompt = false;
        _vm.save();
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.duplicateKeys.text')) + "\n  ")]), _c(VDialog, {
    attrs: {
      "max-width": "900",
      "persistent": ""
    },
    model: {
      value: _vm.showFormDialog,
      callback: function ($$v) {
        _vm.showFormDialog = $$v;
      },
      expression: "showFormDialog"
    }
  }, [_c('core-n20Card', {
    staticClass: "dt-card-text-01 px-0 mx-0",
    attrs: {
      "form": _vm.formComponent,
      "title": _vm.dialogTitle,
      "buttons": _vm.dialogButtons,
      "offset": 34
    },
    on: {
      "close": function ($event) {
        _vm.formComponent = null;
        _vm.updateSwitchParsers();
        _vm.showFormDialog = false;
      },
      "save": function ($event) {
        return _vm.saveParserPreflight();
      }
    }
  }, [_vm.showFormDialog ? _c(VContainer, {
    attrs: {
      "fluid": ""
    }
  }, [_c(VForm, {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    },
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_vm.parserPath === '__switch' ? _c('div', {
    staticClass: "mt-4"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.switchParserHeaderText')) + "\n            "), _vm.switchParsers[_vm.parserPath] ? _c('niota-classic-devicetypes-packet-parser-default', {
    attrs: {
      "parser-config": _vm.switchParsers[_vm.parserPath],
      "switchParserMode": "",
      "readonly": _vm.readonly,
      "hide-predefined-parser-selection": _vm.hidePredefinedParserSelection
    },
    on: {
      "config-updated": _vm.onparserConfigInternalUpdated,
      "validate-form": function ($event) {
        return _vm.$refs.form.validate();
      }
    }
  }) : _vm._e(), _c('niota-classic-devicetypes-packet-parser-payload-test', {
    attrs: {
      "parser-config": _vm.switchParsers,
      "accountId": _vm.accountId,
      "parserType": "multi",
      "custom-test-function": _vm.customTestFunction
    }
  })], 1) : _c('div', [_c('niota-classic-devicetypes-packet-parser-single', {
    ref: "single-parser",
    attrs: {
      "parser-config": _vm.switchParsers[_vm.parserPath],
      "accountId": _vm.accountId,
      "hide-predefined-parser-selection": _vm.hidePredefinedParserSelection
    },
    on: {
      "config-updated": _vm.onparserConfigInternalUpdated,
      "save-parser": function ($event) {
        _vm.showFormDialog = false;
      }
    }
  })], 1)])], 1) : _vm._e()], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "justify": "center",
      "align": "center"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-code-branch",
      "disabled": _vm.readonly
    },
    on: {
      "click": function ($event) {
        return _vm.editParser('__switch');
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.editSwitchParser')) + "\n      ")])], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "justify": "center",
      "align": "center"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-anchor",
      "disabled": _vm.readonly
    },
    on: {
      "click": function ($event) {
        return _vm.editParser('__default');
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.editDefaultParser')) + "\n      ")])], 1)], 1), _c(VExpansionPanels, {
    staticClass: "my-4 dt-card-text-01",
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_c(VIcon, {
    attrs: {
      "color": _vm.color,
      "dark": ""
    }
  }, [_vm._v("fal fa-code-branch")]), _vm._v("\n            " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.parserList')) + "\n        ")], 1)]), _c(VExpansionPanelContent, [_c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_vm._l(_vm.switchParserList, function (parser) {
    return _c(VCol, {
      key: `parser_${parser}`,
      attrs: {
        "cols": "6",
        "md": "4",
        "lg": "3"
      }
    }, [_c(VHover, {
      attrs: {
        "open-delay": "200"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function ({
          hover
        }) {
          return [_c(VCard, {
            staticClass: "pa-3 mx-0",
            style: `min-height: 150px; cursor: pointer; border: 1px solid ${_vm.borderColor};`,
            attrs: {
              "elevation": hover ? 6 : 2,
              "disabled": _vm.readonly
            },
            on: {
              "click": function ($event) {
                return _vm.editParser(parser);
              }
            }
          }, [_c('div', {
            staticClass: "duplicate-parser-icon"
          }, [_c(VIcon, {
            attrs: {
              "size": "small",
              "color": _vm.color
            },
            on: {
              "mousedown": function ($event) {
                $event.stopPropagation();
              },
              "click": function ($event) {
                $event.stopPropagation();
                return _vm.duplicateParser(parser);
              }
            }
          }, [_vm._v("\n                    fal fa-clone\n                  ")])], 1), _c('h4', [_vm._v(_vm._s(parser))]), _c('p', [_c('i', {
            staticClass: "fal fa-square-root-alt"
          }), _vm._v("\n                  Formula: " + _vm._s(_vm.formulaForSwitchParser(parser)) + "\n                ")])])];
        }
      }], null, true)
    })], 1);
  }), _vm.switchParserList.length === 0 ? _c(VAlert, {
    staticClass: "mb-1",
    attrs: {
      "value": true,
      "color": "transparent",
      "icon": "fal fa-comment-exclamation"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n          ")]) : _vm._e()], 2)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };